// import React from "react";
// import LeftSidebar from "../../Sidebars/LeftSidebar";
// import RightSidebar from "../../Sidebars/RightSidebar";

// const Carpet = () => {
//   return (
//     <> 
// <LeftSidebar/>
//     <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
//       <div className="text-sm text-gray-600 mb-4">
//         <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; <span className="underline">Hizmetler</span> &nbsp;&gt;&nbsp; Halı Yıkama
//       </div>

//       <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">İstanbul HALI YIKAMA </h1>

//       <div className="space-y-6">
//         <p>
//           İstanbul Temizlik Servisi olarak, İstanbul'nın neredeyse tüm ilçelerine kalitemizi ulaştırma gayreti içerisindeyiz. Yıllar önce hayata geçirdiğimiz halı yıkama atölyemiz, bugün binlerce müşterimiz için çalışmakta ve müşteri memnuniyeti odaklı çalışma prensibimiz sayesinde bu sayı milyarlara ulaşmaktadır.
//         </p>

//         <p>
//           Prensiplerimiz doğrultusunda, kaliteli hizmet vermek ve müşteri memnuniyetini en üst noktada yaşatmak için tüm ekibimiz ile gayretli bir çalışma sürdürmekteyiz. İstanbul Halı Yıkama sektöründe yer alan firmalar arasında zirvede oluşumuzdan dolayı, bizlere büyük görevler düşmektedir.
//         </p>

//         <p>
//           En kaliteli hizmeti en uygun fiyatlarla müşterilerimize sunabilmek için Halı Yıkama sektöründe birçok farklı devrim gerçekleştirdik. Tam otomatik makinelerden, CE belgeli temizlik malzemelerine kadar yaptığımız yenilikler tüm Türkiye’ye örnek olmuştur.
//         </p>

//         <p>
//           Evden alma ve eve bırakma sistemini layıkıyla uygulayan firmamız, sizlere bir telefon kadar yakındır. Halılarınızı teslim aldıktan sonra türünüze göre uygun makinelerde yıkıyor, doğal kurutma ve tam otomatik paketleme ile teslim ediyoruz.
//         </p>

//         <p>
//           Bu sektörde, özellikle İstanbul’da tam otomatik sistemi bu kadar uygun fiyatla sunan başka bir firma olmadığını iddia ediyoruz. Etik değerlerimizle birlikte sizlere hizmet veriyoruz.
//         </p>

//         <p>
//           7/24 Whatsapp hattımız ve telefon numaralarımız ile bize ulaşabilir, halı yıkatma talebinde bulunabilirsiniz. 
//         </p>
        

//         <h2 className="text-xl font-bold text-[#003132]">🧼 Profesyonel Halı Yıkama Hizmeti</h2>
//         <p>
//           Halılar, gözle görülmeyen bakteri, akar ve toz zerrecikleriyle dolabilir. Firmamız, bu birikimleri ortadan kaldırır ve halılarınızı ilk günkü gibi yapar.
//         </p>

//         <h2 className="text-xl font-bold text-[#003132]">💧 Halı Yıkama Sürecimiz</h2>
//         <ol className="list-decimal list-inside space-y-2">
//           <li>Ön inceleme ve türüne göre sınıflandırma</li>
//           <li>Toz alma ve ön temizlik</li>
//           <li>Leke analizi ve ön müdahale</li>
//           <li>Tam otomatik makinelerde yıkama</li>
//           <li>Durulama ve dezenfekte</li>
//           <li>Yüksek devirde sıkma ve kurutma odasında kurutma</li>
//           <li>Son kontrol ve paketleme</li>
//         </ol>

//         <h2 className="text-xl font-bold text-[#003132]">🧺 Kullandığımız Ürünler</h2>
//         <ul className="list-disc list-inside">
//           <li>Çevre dostu ve biyolojik olarak çözünübilen deterjanlar</li>
//           <li>Halı dokusuna zarar vermeyen özel ürünler</li>
//           <li>Antibakteriyel ve antialerjik solüsyonlar</li>
//         </ul>

//         <h2 className="text-xl font-bold text-[#003132]">✅ Neden Bizi Tercih Etmelisiniz?</h2>
//         <ul className="list-disc list-inside">
//           <li>Modern ekipman ve profesyonel kadro</li>
//           <li>Tüm halı türlerine uygun yıkama yöntemleri</li>
//           <li>Ücretsiz servis ve zamanında teslim</li>
//           <li>Mücteri memnuniyeti odaklı çalışma</li>
//           <li>Uygun fiyat, maksimum kalite</li>
//         </ul>

//         <p>
//           Halı yıkama sürecimizde her adım sistemimize kayıt edilir. Hijyenik ambalajla kapınıza teslim ediyoruz. Profesyonel hizmetimizle halılarınıza ömür katıyoruz.
//         </p>
//       </div>
//     </div>
//     <RightSidebar/>
// </>
//   );
// };

// export default Carpet;
import React from "react";

import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const Carpet = () => {
  return (
    <>
     

      <div className="max-w-7xl mx-auto py-6 px-4 grid grid-cols-1 lg:grid-cols-4 gap-8">
        {/* Sol Sidebar - sadece masaüstü için */}
        <div className="hidden lg:block">
          <LeftSidebar />
        </div>

        {/* Ana içerik */}
        <main className="lg:col-span-2">
          <div className="text-sm text-gray-600 mb-4">
            <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp;
            <span className="underline">Hizmetler</span> &nbsp;&gt;&nbsp; Halı Yıkama
          </div>

          <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">
            İstanbul HALI YIKAMA HİZMETİ
          </h1>

          <div className="space-y-6 text-gray-800 leading-relaxed">
            <p>
              İstanbul Temizlik Servisi olarak İstanbul'nın tüm ilçelerine yayılmış profesyonel kadromuzla,
              halılarınızı en hijyenik ve güvenli koşullarda temizliyoruz. Halı temizliği yalnızca
              görsel temizlikle sınırlı değildir; sağlığınızı doğrudan etkileyen bir hizmettir.
              Özellikle çocuklu aileler, evcil hayvan sahipleri ve alerjik bireyler için
              hijyenik halı temizliği hayati öneme sahiptir.
            </p>

            <h2 className="text-xl font-semibold">🔬 Halı Yıkamada Kullandığımız Teknoloji</h2>
            <p>
              Firmamızda kullanılan makineler son teknoloji ürünü tam otomatik halı yıkama
              sistemleridir. Her halının dokusuna özel programlarla çalışan makinelerimiz, hem
              halınıza zarar vermez hem de derinlemesine temizlik sağlar.
            </p>
            <ul className="list-disc list-inside space-y-2 mt-2">
              <li>Çift yönlü fırçalama ve çırpma sistemi</li>
              <li>Ozonlu antibakteriyel durulama</li>
              <li>Güneş ışığı görmeyen steril kurutma odası</li>
              <li>Her yıkama sonrası makine dezenfeksiyonu</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6">🧪 Sağlığa Zararsız Deterjanlar</h2>
            <p>
              Halılarınızın temizliğinde organik ve biyolojik olarak çözünür deterjanlar
              kullanıyoruz. Bu deterjanlar:
            </p>
            <ul className="list-disc list-inside space-y-2 mt-2">
              <li>Çocuklar ve evcil hayvanlar için güvenlidir</li>
              <li>Yün, ipek, akrilik ve el dokuma halılara zarar vermez</li>
              <li>Kalıntı bırakmaz, kötü koku oluşumunu önler</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6">📦 Teslimat Süreci ve Zamanlama</h2>
            <p>
              Halılarınız adresinizden ücretsiz olarak alınır ve ortalama <strong>2 ila 3 iş günü</strong>
              içerisinde tekrar adresinize teslim edilir. Aynı gün teslim seçeneğimiz acil işler
              için ek hizmet olarak sunulmaktadır.
            </p>

            <h2 className="text-xl font-semibold mt-6">📍 Neden İstanbul Temizlik Servisi?</h2>
            <p>Bizimle çalışmanız için başlıca sebepler:</p>
            <ul className="list-disc list-inside space-y-2 mt-2">
              <li>✔️ Ücretsiz servis & zamanında teslim</li>
              <li>✔️ Belgeli, şebeke suyu kullanılan işletme</li>
              <li>✔️ Organik deterjan ve antibakteriyel hijyen</li>
              <li>✔️ Alanında uzman deneyimli kadro</li>
              <li>✔️ %100 müşteri memnuniyeti garantisi</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6">💰 Fiyat Politikamız</h2>
            <p>
              Halı yıkama fiyatlarımız halı cinsine, büyüklüğüne ve leke durumuna göre değişiklik
              gösterebilir. Ortalama metrekare fiyatlarımız ve kampanyalar hakkında detaylı bilgi
              için bizimle iletişime geçebilirsiniz.
            </p>

            <h2 className="text-xl font-semibold mt-6">📞 İletişim</h2>
            <p>
              Hemen <strong>Whatsapp, telefon</strong> ya da <strong>web formu</strong> üzerinden
              sipariş verebilir, fiyat teklifi alabilirsiniz. Temiz bir halı, sağlıklı bir ev
              demektir. Bize ulaşın, farkı görün!
            </p>
          </div>

          {/* Mobilde sola düşen sidebar buraya gelecek */}
          <div className="block lg:hidden mt-10">
            <LeftSidebar />
          </div>
        </main>

        {/* Sağ Sidebar - tüm ekranlarda görünür */}
        <div className="w-full">
          <RightSidebar />
        </div>
      </div>

      
    </>
  );
};

export default Carpet;
